import { INVESTIGATION_HISTORY_PANEL_SCROLL_AREA_SELECTOR } from "#src/routes/investigations/history/consts";

export const INVESTIGATION_HISTORY_PANEL_SCROLL_AREA_ATTRIBUTE =
  "data-investigation-history-scroll-area";

/**
 * Resolves the panel scrollport ancestor for a history list root element.
 * Returns null when the list root itself incorrectly hosts the scrollport.
 */
export const resolveInvestigationHistoryPanelScrollAreaFromListRoot = (
  listRootElement: Element | null
): HTMLElement | null => {
  const scrollAreaElement =
    listRootElement?.closest(
      INVESTIGATION_HISTORY_PANEL_SCROLL_AREA_SELECTOR
    ) ?? null;

  if (!(scrollAreaElement instanceof HTMLElement)) {
    return null;
  }

  if (scrollAreaElement === listRootElement) {
    return null;
  }

  return scrollAreaElement;
};
